import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noNumericAfterDotComValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null | any => {
    const companyEmail = control?.value as string;
    const afterDotCom = companyEmail?.substring(companyEmail.lastIndexOf('@'));
    const textSearch = afterDotCom?.substring(afterDotCom.indexOf('.'));
    const containsNumbers = /\d+/g;
    if (textSearch?.match(containsNumbers)) {
      return containsNumbers ? { numericAfterDotCom: true } : null;
    } else if(afterDotCom?.includes('.') != true) {
      return containsNumbers ? { numericAfterDotCom: true } : null;
    }
  };
}
